module.exports = __webpack_public_path__ + "img/sandiso-profile-min.56556f9d.jpg";